import { put, select } from 'redux-saga/effects';
import axios from 'src/api/Api';
import { errorHandler } from 'src/errorHandler/errorHandler';
import { logUiErrorToBackend } from 'src/utils/logUiErrorToBackend';
import {
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS,
    GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE,
} from '../actions';
import {
    convertObjectToQueryParams,
    updateIsAllTerritoryId,
} from 'src/utils/util';

export default function* getProductsByBrandOrSuperCategory(action) {
    const { territoryId, isUHOrder } = yield select((state) => ({
        territoryId: state.surgeryReducer.surgeryDetails.territoryId,
        isUHOrder: state.surgeryDetailsReducer?.surgeryData?.surgeryDetails?.isSEorUH
    }));
    const { isMastOrder } = yield select((state) => ({
        isMastOrder: state.loginReducer.isMastOrder
    }));
    const { isMastOrderTemplate } = yield select((state) => ({
        isMastOrderTemplate: state.commonTemplateReducer.isMastOrderTemplate
    }));
    const url = `/occ/v2/${localStorage.getItem(
        'baseSiteId'
    )}/products/productDetailsByFacetCategoryBrand?`;
    const params = convertObjectToQueryParams({
        ...action.payload,
        territoryId: updateIsAllTerritoryId(territoryId),
        isMastOrder:isMastOrder || isMastOrderTemplate,
    });
    let finalUrl = url + `${params}&uhOrder=${isUHOrder ? isUHOrder : false}`;
    try {
        let result = yield axios
            .get(finalUrl)
            .then((response) => response.data);
        let updatedData = {};
        let brandRefineData = [];
        if (result?.subCategoryRefineData) {
            updatedData = result?.subCategoryRefineData?.map((cat) => {
                return {
                    ...cat,
                    classificationRefineData: cat?.classificationRefineData.map(
                        (item) => {
                            return {
                                ...item,
                                isChecked: item.selected
                                    ? item.selected
                                    : false,
                            };
                        }
                    ),
                };
            });
        }
        //added these function for brand filter
        if (result?.brandRefineData) {
            brandRefineData = result.brandRefineData?.map((item) => {
                return {
                    ...item,
                    isChecked: item.selected ? item.selected : false,
                };
            });
        }
        //added these function for brand filter
        if (result?.brandRefineData?.length > 0) {
            result.brandRefineData = brandRefineData;
        }

        if (result?.subCategoryRefineData?.length > 0) {
            result.subCategoryRefineData = updatedData;
        }
        yield put({
            type: GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_SUCCESS,
            productGuideData: result,
        });
    } catch (e) {
        logUiErrorToBackend(e, {
            apiEndPoint: finalUrl,
            requestPayload: action.payload
        });
        yield put({
            type: GET_PRODUCTS_BY_BRAND_OR_SUPERCATEGORY_FAILURE,
            templateError: errorHandler('503'),
        });
    }
}
